import { Box, Grid, TextField } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { buildTitleValidation, findMaxCharLength } from "@platformx/utilities";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles({
  customTextField: {
    "& input::placeholder": {
      fontSize: "28px",
      fontWeight: "700",
      color: "#89909A",
      opacity: 0.6,
    },
    "& .Platform-x-FilledInput-root": {
      border: "1px dashed #CCCFD4 !important",
      backgroundColor: "transparent !important",
      borderRadius: "4px",
      transition: "all 0.2s ease",
      "&:hover": {
        backgroundColor: "#F5F6F8 !important",
        border: "1px dashed #2E7BF5 !important",
      },
      "&.Mui-focused": {
        backgroundColor: "#F5F6F8 !important",
        border: "1px dashed #2E7BF5 !important",
      },
      "& input": {
        paddingLeft: "10px",
        paddingRight: "10px",
        fontWeight: 700,
        fontFamily: "Inter", // <== need to change in future
        cursor: "text",
      },
    },
  },
});

export default function Title({ state, setState }) {
  const { t } = useTranslation();
  const classes = useStyles();
  const TITLE_VALIDATION = buildTitleValidation("article");

  const handleTitleChange = (e) => {
    const newVal = e.target.value;
    setState({
      ...state,
      CommonFields: {
        ...state.CommonFields,
        title: newVal,
        settings: { ...state.CommonFields.settings, socialog_title: newVal },
      },
    });
  };

  return (
    <Box
      sx={{
        fontSize: "28px",
        marginTop: 0,
        marginBottom: 0,
        backgroundColor: "white",
      }}>
      <Grid container>
        <Grid item xs={8} md={12}>
          <TextField
            classes={{ root: classes.customTextField }}
            variant='filled'
            margin='normal'
            required
            fullWidth
            inputProps={{
              style: { fontSize: "28px", lineHeight: "1.4" },
              maxLength: findMaxCharLength(TITLE_VALIDATION),
            }}
            id='title'
            name='title'
            autoComplete='title'
            autoFocus
            onChange={handleTitleChange}
            placeholder={t("enter_title")}
            InputProps={{ disableUnderline: true }}
            value={state?.CommonFields?.title || ""}
          />
        </Grid>
      </Grid>
    </Box>
  );
}
